<template>
	<div class="flex w-full items-center justify-between p-4 fixed bottom-0 left-0 z-50 bg-white/90 backdrop-blur-sm h-14" v-if="is_tg_bottom_menu_visible">
		<UButton 
            v-if="is_tg_main_button_visible"
            color="primary"
            variant="solid"
            size="lg"
            block
            @click="handleMainClick"
        >
            {{ tg_main_button_text }}
        </UButton>
	</div>
</template>

<script setup lang="ts">
import { UButton } from '#components';

const { getMainButtonHandler } = useTelegramMainButton();

const main_store = useMainStore();
const { is_tg_main_button_visible, is_tg_bottom_menu_visible, tg_main_button_text } = storeToRefs(main_store);

watch(
	() => is_tg_main_button_visible,
	(newValue) => {
		if (newValue.value) {
			console.error('Main button is visible');
		} else {
			console.error('Main button is hidden');
		}
	}
);

const handleMainClick = async () => {
	console.log('Main button clicked');
	const handler = getMainButtonHandler();
	console.log('Main button handler:', handler);
	if (handler) {
		try {
			await handler();
		} catch (error) {
			console.error('Error in virtual MainButton handler:', error);
		}
	}
};
</script>